import * as luxon from 'luxon';
import Vue from 'vue';
import DocumentData = firebase.firestore.DocumentData;
import {MAFUser, UserTransaction} from '@/store/User/types';
import {DateTime} from 'luxon';
import {baseClass} from '@/store/types';
import * as firebase from 'firebase';
import DocumentReference = firebase.firestore.DocumentReference;
import Timestamp = firebase.firestore.Timestamp;
import {PlaceDetailsResult} from '@google/maps';
import {FirebaseError} from 'firebase';

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:max-classes-per-file */
/* tslint:disable:class-name */
/* tslint:disable:variable-name */
/* tslint:disable:no-bitwise */
/* tslint:disable:no-console */

export interface FriendState {
  friends: MAFUser[] | undefined;
  messages: UserWithMessage[] | undefined;
  currentlyChattingWith: MAFUser | undefined;
  meetups: Meetup[] | undefined;
  chatPrompts: ChatPrompt | undefined;
  connections: WebRTCRequest[] | undefined;
  connectionRequests: MAFUser[] | undefined;
  transactions: UserTransaction[] | undefined;
  toConnections: WebRTCRequest[] | undefined;
  senderConnections: WebRTCRequest[] | undefined;
}


export interface meetup {
  when: Date | string | undefined;
  where: PlaceDetailsResult | undefined;
  inviter: string | undefined;
  invitee: string | undefined;
  inviterRef: DocumentReference | undefined;
  inviteeRef: DocumentReference | undefined;
  confirmed: boolean;
  canceled: boolean;
}

export class Meetup extends baseClass implements meetup {
  public Inviter: MAFUser | undefined;
  public Invitee: MAFUser | undefined;
  public canceled: boolean;
  public confirmed: boolean;
  public inviter: string | undefined;
  public invitee: string | undefined;
  public inviterRef: DocumentReference | undefined;
  public inviteeRef: DocumentReference | undefined;
  public when: Date | string | undefined;
  public where: PlaceDetailsResult | undefined;
  public id: string | undefined;

  constructor(payload: Meetup | meetup | DocumentData) {
    super();
    this.confirmed = false;
    this.canceled = false;
    if (payload) {
      // TODO: fix IF chaining - not supportable
      this.when = payload.when ?
        typeof payload.when === 'string' ?
        luxon.DateTime.fromISO(payload.when).toJSDate() : payload.when instanceof Date ?
        payload.when : payload.when.toDate() : new Date();
      this.where = payload.where;
      this.invitee = payload.invitee;
      this.inviter = payload.inviter;
      this.confirmed = payload.confirmed ? payload.confirmed : false;
      this.canceled = payload.canceled ? payload.canceled : false;
      this.inviteeRef = payload.inviteeRef;
      this.inviterRef = payload.inviterRef;
    }
  }

  public toPlainObj(): object {
    return {
      when: this.when instanceof Date ? Timestamp.fromDate(this.when) : this.when,
      where: this.where,
      invitee: this.invitee,
      inviter: this.inviter,
      confirmed: this.confirmed,
      canceled: this.canceled,
      inviteeRef: this.inviteeRef,
      inviterRef: this.inviterRef,
    };
  }

  public canICancel(myUid: string): boolean {
    return this.inviter === myUid;
  }

  public canIConfirm(myUid: string): boolean {
    return this.invitee === myUid;
  }

  public getUsers() {
    const self = this;
    return new Promise(((resolve) => {
      if (self.inviterRef) {
        const ir = self.inviterRef.get().then((doc) => {
          self.Inviter = new MAFUser(doc.data());
        });
        if (self.inviteeRef) {
          self.inviteeRef.get().then((doc) => {
            this.Invitee = new MAFUser(doc.data());
            resolve();
          });
        } else {
          resolve();
        }
      } else if (self.inviteeRef) {
        self.inviteeRef.get().then((doc) => {
          this.Invitee = new MAFUser(doc.data());
          resolve();
        });
      } else {
        resolve();
      }
    }));
  }
}
export enum WebRTCRequestState {
  Requested = 'Requested',
  Accepted = 'Accepted',
  Connecting = 'Connecting',
  Connected = 'Connected',
  Declined = 'Declined',
  Ending = 'Ending',
  Ended = 'Ended',
}


export class WebRTCRequest {
  public to: string = '';
  public sender: string = '';
  public sdp: RTCSessionDescription | null;
  public sent: Date | string | undefined;
  public state: WebRTCRequestState;
  public Reference: DocumentReference | undefined;
  public Sender: MAFUser |undefined;
  public To: MAFUser | undefined;
  public isVideo: boolean = false;
  public isAudio: boolean = false;

  constructor(
    payload: WebRTCRequest | DocumentData | null,
    to: string | undefined | null,
    sender: string | undefined | null,
    sdp: RTCSessionDescription | null,
    sent: Date | string | undefined,
    state: WebRTCRequestState | null,
    isVideo: boolean | false,
    isAudio: boolean | false ) {

    if ( payload ) {
      this.sdp = payload.sdp;
      this.to = payload.to;
      this.sender = payload.sender;
      this.sent = baseClass.convertToJSDate(payload.sent);
      this.state = payload.state;
      this.isVideo = payload.isVideo;
      this.isAudio = payload.isAudio;
    } else {
      this.sender = sender ? sender : '';
      this.sdp = sdp;
      this.to = to ? to : '';
      this.sent = baseClass.convertToJSDate(sent);
      this.state = state ? state : WebRTCRequestState.Requested;
      this.isVideo = isVideo;
      this.isAudio = isAudio;
    }
  }

  public async getUsers(firestore: firebase.firestore.Firestore ) {
    if ( this.sender ) {
      const doc = await firestore.collection('users').doc(this.sender).get();
      if ( doc.exists ) {
        this.Sender = new MAFUser(doc.data());
      }
    }
    if ( this.to ) {
      const doc = await firestore.collection('users').doc(this.to).get();
      if ( doc.exists ) {
        this.To = new MAFUser(doc.data());
      }
    }
  }

  public otherUser( self: string ): MAFUser | undefined {
    if ( self !== this.sender ) {
      return this.Sender;
    }
    return this.To;
  }

  public toPlainObj(): object {
    return {
      sender: this.sender,
      to: this.to,
      state: this.state,
      sdp: JSON.parse(JSON.stringify(this.sdp)),
      sent: this.sent instanceof Date ? Timestamp.fromDate(this.sent) : this.sent,
    };
  }

  public async updateWebRTC(): Promise<any> {
    if ( this.Reference ) {
      try {
        await this.Reference.set(this.toPlainObj(), {merge: true});
      } catch (error) {
        console.error(error);
      }
    }
  }

  public setDocumentReference( doc: DocumentReference ) {
    this.Reference = doc;
  }
}

export class message {

    public to: string;
    public from: string;
    public sent: Date | string | undefined;
    public message: string;
    public userRef: DocumentReference | undefined;
    public imgRef: string | undefined;
    public isMeetupNotification: boolean;
    public ImgRef: string | undefined;
    public prompt: MessagePrompt = new MessagePrompt(null);

    constructor(
        to: string | undefined,
        from: string | undefined,
        sent: Date | string | undefined,
        messageParam: string | undefined,
        userRef: DocumentReference,
        isMeetupNotification: boolean | null | undefined,
        imgRef: string | null | undefined,
        prompt: MessagePrompt | null | undefined,
    ) {
        this.to = to ? to : '';
        this.from = from ? from : '';
        this.sent = baseClass.convertToJSDate(sent);
        this.userRef = userRef;
        this.message = messageParam ? messageParam : '';
        this.imgRef = imgRef ? imgRef : '';
        this.isMeetupNotification = !!isMeetupNotification;
        this.prompt = new MessagePrompt(prompt);
    }

    public async getImageUrl(VueInstance: Vue): Promise<string> {
        return new Promise<string>((resolve) => {
            const self = this;
            if (self.imgRef) {
                VueInstance.$storage.ref(`messages/${self.imgRef}`).getDownloadURL().then( (url) => {
                    resolve(url);
                }, (e: FirebaseError) => {
                    resolve('');
                });
            } else {
                resolve('');
            }
        });
    }

    public toPlainObj(): object {
        return {
            to: this.to,
            from: this.from,
            sent: this.sent instanceof Date ? Timestamp.fromDate(this.sent) : this.sent,
            userRef: this.userRef,
            message: this.message,
            imgRef: this.imgRef,
            isMeetupNotification: this.isMeetupNotification,
            prompt: baseClass.staticToPlainObj(this.prompt),
        };
    }

    public formatDate(): string {
        const date = baseClass.convertToJSDate(this.sent);
        return date ? DateTime.fromJSDate(date).toLocaleString(DateTime.DATETIME_SHORT) : '';
    }

}

export class ChatPrompt {
    public general: MessagePrompt[] = [];
    public food: MessagePrompt[] = [];
    public boardgames: MessagePrompt[] = [];
    public movies: MessagePrompt[] = [];
    public pets: MessagePrompt[] = [];
    public sports: MessagePrompt[] = [];
    public tv: MessagePrompt[] = [];
    public videogames: MessagePrompt[] = [];
    public yardgames: MessagePrompt[] = [];
    constructor(payload: ChatPrompt | DocumentData | null | undefined) {
        if (payload) {
            if (payload.general) {
                payload.general.forEach((mp: MessagePrompt | DocumentData) => {
                    this.general.push(new MessagePrompt(mp));
                });
            }
            if (payload.food) {
                payload.food.forEach((mp: MessagePrompt | DocumentData) => {
                    this.food.push(new MessagePrompt(mp));
                });
            }
            if (payload.boardgames) {
                payload.boardgames.forEach((mp: MessagePrompt | DocumentData) => {
                    this.boardgames.push(new MessagePrompt(mp));
                });
            }
            if (payload.movies) {
                payload.movies.forEach((mp: MessagePrompt | DocumentData) => {
                    this.movies.push(new MessagePrompt(mp));
                });
            }
            if (payload.pets) {
                payload.pets.forEach((mp: MessagePrompt | DocumentData) => {
                    this.pets.push(new MessagePrompt(mp));
                });
            }
            if (payload.sports) {
                payload.sports.forEach((mp: MessagePrompt | DocumentData) => {
                    this.sports.push(new MessagePrompt(mp));
                });
            }
            if (payload.sports) {
                payload.sports.forEach((mp: MessagePrompt | DocumentData) => {
                    this.sports.push(new MessagePrompt(mp));
                });
            }
            if (payload.tv) {
                payload.tv.forEach((mp: MessagePrompt | DocumentData) => {
                    this.tv.push(new MessagePrompt(mp));
                });
            }
            if (payload.videogames) {
                payload.videogames.forEach((mp: MessagePrompt | DocumentData) => {
                    this.videogames.push(new MessagePrompt(mp));
                });
            }
            if (payload.yardgames) {
                payload.yardgames.forEach((mp: MessagePrompt | DocumentData) => {
                    this.yardgames.push(new MessagePrompt(mp));
                });
            }
        }
    }
}

export class MessagePrompt {
  public message: string = '';
  public responses: MessagePrompt[] = [];
  public type: string = '';

  constructor(payload: MessagePrompt | DocumentData | null | undefined) {
    if (payload) {
      this.message = payload.message;
      this.type = payload.type;
      if (payload.responses ) {
        payload.responses.forEach((mp: MessagePrompt | DocumentData) => {
          this.responses.push(new MessagePrompt(mp));
        });
      }
    }
  }
}

export class UserWithMessage {
  public user: MAFUser;
  public messages: message[];

  constructor(user: MAFUser, messages: message[]) {
    this.user = user;
    this.messages = messages;
  }
}
